import React, { useCallback } from "react";
import ItemComponent from "./ItemComponent";
import update from "immutability-helper";
import { ItemTypes } from "../Internal/ItemTypes";

const CheckboxesComponent = ({ config, onChange }) => {
	let items = config.extraSettings?.items || [ { index: 0, text: "" } ];

	const updateItems = updateFunction => {
		const newConfig = {
			extraSettings: {
				items: [ ...items ],
				dataSource: "Static",
				storage: "Id",
				identity: "text",
			},
		};
		updateFunction(newConfig.extraSettings.items);
		onChange(newConfig);
	};

	const onItemChange = (index, newValue) => updateItems(items => (items[index].text = newValue));
	const deleteItem = index => updateItems(items => items.splice(index, 1));
	const addItem = () => updateItems(items => items.push({ index: items.length, text: "" }));
	const moveItem = useCallback(
		(dragIndex, hoverIndex) => {
			const dragItem = items[dragIndex];
			const updatedItems =
				update(items, {
					$splice: [
						[ dragIndex, 1 ],
						[ hoverIndex, 0, dragItem ],
					],
				});
			items = updatedItems;
			updateItems((items => items));
		},
		[ items ],
	);

	return (
		<>
			{items.map((item, index) => {
				return (
					<ItemComponent
						key={index}
						item={item}
						index={index}
						itemType={ItemTypes.CHECKBOX_ITEM_COMPONENT}
						onItemChange={onItemChange}
						deleteItem={deleteItem}
						addItem={addItem}
						moveItem={moveItem}
						totalItems={items.length}
					>
						<input type="checkbox" disabled={true} />
					</ItemComponent>
				);
			})}
		</>
	);
};

CheckboxesComponent.information = {
	type: "cayuseCheckboxes",
	name: "Checkboxes",
};

export default CheckboxesComponent;
